module.exports = __webpack_public_path__ + "static/media/SLAMLogo.3f0a9171.png";